/**
 * Styles.
 */
import './style.scss';

/**
 * External Dependencies
 */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'reactstrap';

/**
 * Internal Dependencies
 */
import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageTitle from '../../components/page-title';
import PageContent from '../../components/page-content';
import NavigationTopRight from '../../components/navigation-top-right';

const Balance = () => {
  const currentUser = useSelector(state => state.currentUser);

  useEffect(() => {
    // Wallet drives its own login via auth-v2 /authorize; with a warm Mayar IdP
    // session it signs in silently. Opened in a NEW TAB so www stays where it
    // is; the button in content.jsx is the fallback when the popup is blocked
    // (no user activation, e.g. a hard reload straight onto /balance).
    if (!process.env.REACT_APP_MAYAR_WALLET_URL) return;
    window.open(`${process.env.REACT_APP_MAYAR_WALLET_URL}/?from=mayar`, '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <PageWrap>
      <PageTitle
        className="d-none d-md-block"
        breadcrumbs={{
          '/': currentUser ? currentUser.name : ' '
        }}
      >
        <Row className="mb-0">
          <Col md="4">
            <h1>Saldo Kamu</h1>
          </Col>
          <Col md="8" className="text-right">
            <NavigationTopRight />
          </Col>
        </Row>
      </PageTitle>
      <PageContent>
        <AsyncComponent component={() => import('./content')} />
      </PageContent>
    </PageWrap>
  );
};

export default Balance;
